import { assert } from '@varos/util-typescript';
import { ReportingLoaderBaseConfig } from '../../../../../../base';
import { RelationManyValueLoader } from './relationManyValueInterface';
import { RelationManyValueAggregate } from './relationManyValueModel';

export function createRelationManyValueLoader(
    config: ReportingLoaderBaseConfig
): RelationManyValueLoader {
    const {
        repository: { research: repository },
    } = config;
    return {
        useLoad(context, props): RelationManyValueAggregate {
            const targetQuery = repository.record.useFind(
                context,
                {
                    collection: props.collection,
                    ids: props.item.value,
                },
                {
                    suspense: true,
                }
            );
            assert(targetQuery.status === 'success', 'expected suspense');
            return {
                property: props.item.property,
                value: props.item.value,
                targets: targetQuery.data,
            };
        },
    };
}
